import React from "react";

const TermsContent = () => {
  return (
    <div className="privacy-content">
      <section className="privacy-section">
        <h3>1. Acceptance of Terms</h3>
        <p>
          By accessing and using Omaha Food Lovers, you accept and agree to be bound by the terms and provisions 
          of this agreement. If you do not agree to abide by these terms, please do not use our service.
        </p>
      </section>

      <section className="privacy-section">
        <h3>2. Description of Service</h3>
        <p>
          Omaha Food Lovers is a rewards program that allows users to earn cashback and rewards when dining at 
          participating restaurants in Omaha, Nebraska. Our services include:
        </p>
        <ul>
          <li>Card linking for automatic cashback tracking</li>
          <li>Points accumulation and rewards redemption</li>
          <li>Restaurant discovery and recommendations</li>
          <li>Dining streak tracking and achievement badges</li>
        </ul>
      </section>

      <section className="privacy-section">
        <h3>3. User Accounts</h3>
        <p>
          To use certain features of our service, you must register for an account. You agree to:
        </p>
        <ul>
          <li>Provide accurate, current, and complete information during registration</li>
          <li>Maintain and update your account information to keep it accurate</li>
          <li>Keep your password secure and confidential</li>
          <li>Accept responsibility for all activities under your account</li>
          <li>Notify us immediately of any unauthorized use of your account</li>
        </ul>
      </section>

      <section className="privacy-section">
        <h3>4. User Responsibilities</h3>
        <p>As a user of Omaha Food Lovers, you agree to:</p>
        <ul>
          <li>Use the service only for lawful purposes</li>
          <li>Not attempt to gain unauthorized access to our systems</li>
          <li>Not use the service to harass, abuse, or harm others</li>
          <li>Not create fake accounts or engage in fraudulent activity</li>
          <li>Comply with all applicable laws and regulations</li>
        </ul>
      </section>

      <section className="privacy-section">
        <h3>5. Rewards and Cashback</h3>
        <p>
          Our rewards program terms include:
        </p>
        <ul>
          <li>Cashback rates are subject to change without notice</li>
          <li>Rewards are earned only at participating restaurants</li>
          <li>Points and rewards have no cash value unless redeemed</li>
          <li>We reserve the right to modify or terminate the rewards program</li>
          <li>Fraudulent activity may result in account termination and loss of rewards</li>
        </ul>
      </section>

      <section className="privacy-section">
        <h3>6. Intellectual Property</h3>
        <p>
          All content, features, and functionality of Omaha Food Lovers are owned by us and are protected by 
          international copyright, trademark, and other intellectual property laws. You may not:
        </p>
        <ul>
          <li>Reproduce, distribute, or create derivative works</li>
          <li>Use our trademarks or logos without permission</li>
          <li>Remove any copyright or proprietary notices</li>
        </ul>
      </section>

      <section className="privacy-section">
        <h3>7. Limitation of Liability</h3>
        <p>
          To the fullest extent permitted by law, Omaha Food Lovers shall not be liable for any indirect, 
          incidental, special, or consequential damages arising from your use of our service. Our total liability 
          shall not exceed the amount you paid, if any, to access the service.
        </p>
      </section>

      <section className="privacy-section">
        <h3>8. Termination</h3>
        <p>
          We reserve the right to suspend or terminate your account at any time for violation of these terms 
          or for any other reason at our sole discretion. Upon termination, your right to use the service 
          will immediately cease.
        </p>
      </section>

      <section className="privacy-section">
        <h3>9. Changes to Terms</h3>
        <p>
          We may modify these terms at any time. We will notify users of material changes by posting the 
          updated terms on our website. Your continued use of the service after such changes constitutes 
          acceptance of the new terms.
        </p>
      </section>

      <section className="privacy-section">
        <h3>10. Governing Law</h3>
        <p>
          These terms shall be governed by and construed in accordance with the laws of the State of 
          Nebraska, without regard to its conflict of law provisions.
        </p>
      </section>

      <section className="privacy-section">
        <h3>11. Contact Us</h3>
        <p>
          If you have any questions about these Terms of Service, please contact us at:
        </p>
        <p className="contact-info">
          Email: legal@omahafoodlovers.com<br />
          Address: Omaha, Nebraska
        </p>
      </section>
    </div>
  );
};

export default TermsContent;
